import { DialogMessagesEnum } from '../enums/dialog-messages.enum';

export class ConfirmationConfig {
  message: string = DialogMessagesEnum.DeleteWallConfirmationMessage;
  header: string = DialogMessagesEnum.DeleteWallConfirmationHeader;
  okVisible = true;
  cancelVisible = false;

  constructor(props: Partial<ConfirmationConfig> = {}) {
    Object.assign(this, props);
  }
}
